import React, { useState } from 'react';

export default function ProfileModal({ user, onClose, onUpdateProfile, onDeleteAccount, onSignOut }) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleToggleSubscribe = async () => {
    setSaving(true);
    try {
      await onUpdateProfile({ subscribed: !user.subscribed });
    } catch {
      // Ignore
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    try {
      await onDeleteAccount();
      onClose();
    } catch {
      // Ignore
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white border-2 border-ink p-4 sm:p-8 max-w-sm w-full relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-ink-faint hover:text-ink text-xl font-body"
        >
          &times;
        </button>

        <h2 className="text-2xl font-serif font-black text-center text-ink mb-1">
          {user.displayName}
        </h2>
        <div className="w-16 mx-auto border-t-2 border-ink mt-1 mb-6" />

        <p className="text-xs text-ink-faint font-body text-center mb-6">
          {user.email}
        </p>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="text-center">
            <p className="text-2xl font-serif font-black text-ink">{user.gamesPlayed}</p>
            <p className="text-xs font-body text-ink-faint">played</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-serif font-black text-ink">{user.currentStreak}</p>
            <p className="text-xs font-body text-ink-faint">streak</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-serif font-black text-ink">{user.maxStreak}</p>
            <p className="text-xs font-body text-ink-faint">best streak</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 mb-6">
          <div className="text-center">
            <p className="text-2xl font-serif font-black text-ink">{(user.bestScore || 0).toFixed(1)}</p>
            <p className="text-xs font-body text-ink-faint">best score</p>
          </div>
          <div className="text-center">
            <p className={`text-2xl font-serif font-black ${user.hasTopFive ? 'text-ink' : 'text-ink-faint'}`}>
              {user.hasTopFive ? '\u2605' : '\uD83D\uDD12'}
            </p>
            <p className="text-xs font-body text-ink-faint">top 5</p>
          </div>
        </div>

        {/* Subscribe toggle */}
        <label className="flex items-center gap-3 py-3 border-t border-ink-faint cursor-pointer">
          <input
            type="checkbox"
            checked={user.subscribed}
            onChange={handleToggleSubscribe}
            disabled={saving}
            className="w-4 h-4 accent-ink"
          />
          <span className="text-sm font-body text-ink">
            Email me the daily puzzle (6 AM ET)
          </span>
        </label>

        {/* Delete account */}
        <div className="border-t border-ink-faint pt-4 mt-4">
          {!confirmDelete ? (
            <button
              onClick={() => setConfirmDelete(true)}
              className="text-sm font-body text-red-600 hover:text-red-800 transition-colors"
            >
              Delete account
            </button>
          ) : (
            <div>
              <p className="text-sm font-body text-ink mb-3">
                This will remove your email and data. Are you sure?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setConfirmDelete(false)}
                  className="px-4 py-2 text-sm font-body border border-ink text-ink hover:bg-cream transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  className="px-4 py-2 text-sm font-body bg-red-600 text-white border border-red-600 hover:bg-red-700 transition-colors"
                >
                  Delete
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
